module.exports = __webpack_public_path__ + "img/new-coupon-tips.cd01b03.png";